// Severity bands for "how long since last practiced". The same thresholds
// drive the dashboard's getting-rusty molecule and the history page's
// rusty-pieces list — each call site maps the discriminator to its own
// palette (brand vars vs raw Tailwind colours).
//
// When the Settings rollup lands a "rusty-after" threshold setting, this
// module is the natural home for that override.

export type RustySeverity = 'never' | 'severe' | 'warning' | 'mild' | 'fresh';

const NEVER_PRACTICED_SENTINEL = 999;
const SEVERE_THRESHOLD = 60;
const WARNING_THRESHOLD = 30;
const MILD_THRESHOLD = 14;

export function classifyRusty(days: number | null | undefined): RustySeverity {
  if (days == null || days >= NEVER_PRACTICED_SENTINEL) return 'never';
  if (days >= SEVERE_THRESHOLD) return 'severe';
  if (days >= WARNING_THRESHOLD) return 'warning';
  if (days >= MILD_THRESHOLD) return 'mild';
  return 'fresh';
}
